import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4lp7ouz3yu: FaireBrandEntity = {
  token: "b_4lp7ouz3yu",
  type: "brand",
  name: "The Good Crisp Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a0848b0efaa164a83e9abb0ab99887fc577f7a8460470fb7c2f05355445d988.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c069405b5e23787cc879e76720af38095caeef560d4065bba5f449add1fec23b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7a0848b0efaa164a83e9abb0ab99887fc577f7a8460470fb7c2f05355445d988.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c069405b5e23787cc879e76720af38095caeef560d4065bba5f449add1fec23b.jpeg",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 42,
  rating: 4.8,
  reviewCount: 218,
  isTopShop: true,
  isInsider: true,
  description:
    "G’day Matt here. I wanted to make something I felt GOOD about giving my kids, so I created these guilt free crisps. We moved from Australia to share them with you.\n\nWe are a better for you stacked chip in 6 delicious flavors!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:08.048Z",
    importedBy: "entity-db-cli",
  },
};
